/* eslint-disable import/extensions */
import { MOBILE_REGEX, REQUIRED_FIELD_ERROR, FIELD_INVALID } from '@masfront/common-b2c'
import { string } from 'yup'

import { SignUpType } from '~/basket/model/lines/signup.model'

const signUpTypeSchemas = {
  signUpType: string().required(REQUIRED_FIELD_ERROR).label('tipo de alta'),
  lineNumber: string().when('signUpType', {
    is: SignUpType.PORTABILITY,
    then: string()
      .matches(MOBILE_REGEX, FIELD_INVALID)
      .required(REQUIRED_FIELD_ERROR)
      .label('teléfono'),
    otherwise: string(),
  }),
  portabilityType: string()
    .label('tipo de portabilidad')
    .when('signUpType', {
      is: SignUpType.PORTABILITY,
      then: string().required(REQUIRED_FIELD_ERROR),
      otherwise: string(),
    }),
}

export default signUpTypeSchemas
